module.exports = __webpack_public_path__ + "static/media/Bg-imac.4767fc1b.png";